import styled from 'styled-components';

export const Container = styled.div`
  width: 85%;
  height: 390px;
  padding: 8px;
  border-radius: 4px;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  box-sizing: border-box;

  p,
  span {
    color: #4d4d4d;
  }

  .listagemParcelasSelecionadas {
    align-items: flex-start;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
    height: 100%;

    > div {
      width: 100%;
    }
  }

  .tituloContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 16px;

    .titulo {
      font-size: 18px;

      font-weight: bold;
      line-height: 28px;
    }

    .parcelasEmAberto {
      font-size: 16px;
      line-height: 24px;
    }
  }

  .containerParcelas {
    height: fit-content;
    max-height: 200px;
    overflow-y: auto;
    padding-right: 8px;
    width: 100%;
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
      opacity: 0.7;
    }

    &::-webkit-scrollbar {
      width: 12px;
      background-color: #f5f5f5;
      opacity: 0.7;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: rgba(0, 0, 0, 0.2);
      opacity: 0.5;
    }
  }

  .textoInformativo {
    width: 100%;
    line-height: 18px;
    font-size: 12px;
    margin-top: 4px;
  }

  @media (max-width: 768px) {
    height: fit-content;
    width: 100%;

    margin-bottom: 16px;
    min-height: fit-content;
  }
`;
